<button class="left" (click)="onZoomOut()" [disabled]="disableZoomOut$ | async"></button>
<div class="title">{{label$ | async}}</div>
<button class="right" (click)="onZoomIn()" [disabled]="disabledZoomIn$ | async"></button>
